var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#E22C32"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    stroke: "#C71706",
    strokeWidth: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.333 27.1666L30.8587 33.8346C31.6301 34.3746 32.0158 34.6446 32.4353 34.7492C32.8059 34.8415 33.1935 34.8415 33.564 34.7492C33.9836 34.6446 34.3692 34.3746 35.1406 33.8346L44.6663 27.1666M26.933 42.3333H39.0663C41.0265 42.3333 42.0066 42.3333 42.7553 41.9518C43.4139 41.6163 43.9493 41.0808 44.2849 40.4223C44.6663 39.6736 44.6663 38.6935 44.6663 36.7333V29.2666C44.6663 27.3064 44.6663 26.3264 44.2849 25.5777C43.9493 24.9191 43.4139 24.3837 42.7553 24.0481C42.0066 23.6666 41.0265 23.6666 39.0663 23.6666H26.933C24.9728 23.6666 23.9927 23.6666 23.244 24.0481C22.5855 24.3837 22.05 24.9191 21.7145 25.5777C21.333 26.3264 21.333 27.3064 21.333 29.2666V36.7333C21.333 38.6935 21.333 39.6736 21.7145 40.4223C22.05 41.0808 22.5855 41.6163 23.244 41.9518C23.9927 42.3333 24.9728 42.3333 26.933 42.3333Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.6f2f5a20d3073111f1e76b651dee72f6.svg";
export { ForwardRef as ReactComponent };